import script from "./ProductCategoryCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCategoryCard.vue?vue&type=script&setup=true&lang=js"

import "./ProductCategoryCard.vue?vue&type=style&index=0&id=57ed0bfc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57ed0bfc"]])

export default __exports__